module.exports = __webpack_public_path__ + "img/hipo.323a97af.svg";